// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 180 ? "App" : chunkId) + "." + {"180":"a377b8ed","586":"dcc26cc1"}[chunkId] + ".chunk.js";
};